module.exports = __webpack_public_path__ + "static/media/Free-Standing-Control-Panel-1.85e04783.jpg";